export default class MapEntry {
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
}
